import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { PoiMapService } from './poi-map.service';

export const Ng1PoiMapModule = angular
  .module('control-room.shared.services.poi-map', [])
  .factory('crPoiMapService', downgradeInjectable(PoiMapService));